import {API} from 'api';

const getCompanies = async () => {
  return (await API.get('/v1/companies')) as Company[];
};

const getTopCompanies = async () => {
  return (await API.get('/v1/companies/top')) as Company[];
};

const getRecentCompanies = async () => {
  return (await API.get('/v1/companies/recent')) as Company[];
};

const getCompany = async (slug: string) => {
  return (await API.get(`/v1/companies/detail/${slug}`)) as Company;
};

const getInterviewGuides = async (slug: string) => {
  return (await API.get(`/v1/companies/interview-guides/${slug}`)) as CompanyInterviewGuide[];
};

export const CompaniesAPI = {
  getCompanies,
  getTopCompanies,
  getRecentCompanies,
  getCompany,
  getInterviewGuides,
};
